<template>
	<div>
		<hr-document-editor :is-saving="isSaving" :is-admin="loggedInEmployee.isAdmin" @save="onSave" @cancel="onCancel"></hr-document-editor>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	import HrDocumentEditor from '@/components/hrDocuments/HrDocumentEditor';

	export default {
		name: 'PageHrDocumentCreate',
		components: {
			HrDocumentEditor
		},
		data() {
			return {
				isSaving: false
			};
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			})
		},
		methods: {
			onSave(hrDocument) {
				this.isSaving = true;
				this.$store.dispatch('hrDocuments/add', hrDocument).then(
					response => {
						this.isSaving = false;
						this.$router.push(`/hrDocuments/policies/`);
					},
					error => {
						this.isSaving = false;
						console.error('Error saving HR Document');
					}
				);
			},
			onCancel() {
				window.history.back();
			}
		},
		created() {
			this.$store.dispatch('setPageTitle', 'New Policy');
		}
	};
</script>

<style></style>
